import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const TOKEN_KEY = "geocarbon_admin_token";

// Токен живёт в sessionStorage — переживает перезагрузку страницы, но
// пропадает при закрытии вкладки. Осознанный компромисс между удобством и
// тем, чтобы не держать токен админки в localStorage бесконечно.
export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (token) => sessionStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => sessionStorage.removeItem(TOKEN_KEY);
export const isAuthenticated = () => Boolean(getToken());

const adminApi = axios.create({ baseURL: API_BASE_URL });

adminApi.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

adminApi.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            clearToken();
        }
        return Promise.reject(error);
    }
);

export const login = async (username, password) => {
    const response = await adminApi.post("/api/admin/login", {
        username,
        password,
    });
    setToken(response.data.access_token);
    return response.data;
};

export const logout = () => {
    clearToken();
};

export const fetchMe = async () => {
    const response = await adminApi.get("/api/admin/me");
    return response.data;
};

export const updateContent = async (page, payload) => {
    const response = await adminApi.put(`/api/admin/content/${page}`, payload);
    return response.data;
};

export const fetchDataSourcesAdmin = async () => {
    const response = await adminApi.get("/api/data-sources");
    return response.data;
};

export const createDataSource = async (name, url) => {
    const response = await adminApi.post("/api/admin/data-sources", {
        name,
        url,
    });
    return response.data;
};

export const updateDataSource = async (id, name, url) => {
    const response = await adminApi.put(`/api/admin/data-sources/${id}`, {
        name,
        url,
    });
    return response.data;
};

export const deleteDataSource = async (id) => {
    await adminApi.delete(`/api/admin/data-sources/${id}`);
};

export const uploadDataset = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    // Пересборка каталога объектов идёт построчно на бэке и может занять
    // пару минут на большом файле — дефолтного таймаута axios (0, то есть
    // без ограничения) достаточно, явно фиксируем это здесь для ясности.
    const response = await adminApi.post("/api/admin/dataset/upload", formData, {
        timeout: 0,
    });
    return response.data;
};

export const extractErrorMessage = (error, fallback) => {
    const detail = error?.response?.data?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail) && detail.length > 0) {
        return detail.map((d) => d.msg || JSON.stringify(d)).join("; ");
    }
    return fallback;
};
